import { api, endpoints } from "api/api";
import { AxiosPromise } from "axios";

export interface AuthorApi {
  id: number;
  firstName: string;
  lastName: string;
  avatar?: string;
}

export interface AuthorFormValues {
  firstName: string;
  lastName: string;
  avatar?: string;
}

const fetchAuthors = (): AxiosPromise<AuthorApi[]> =>
  api.get<AuthorApi[]>(endpoints.SHOP.BLOG.AUTHORS.GET());

const createAuthor = (data: AuthorFormValues): AxiosPromise<{ id: number }> =>
  api.post<{ id: number }>(endpoints.SHOP.BLOG.AUTHORS.CREATE(), data);

const updateAuthor = (id: number, data: AuthorFormValues): AxiosPromise<void> =>
  api.put<void>(endpoints.SHOP.BLOG.AUTHORS.UPDATE(id), data);

const deleteAuthor = (id: number): Promise<void> => api.delete(endpoints.SHOP.BLOG.AUTHORS.DELETE(id));

export const authorsApi = {
  fetchAuthors,
  createAuthor,
  updateAuthor,
  deleteAuthor,
};
